<div class="grid-page mx-sm-4 pt-4">
    @if (tabs.length > 1) {
        <dx-tabs
            keyExpr="key"
            class="mb-3"
            [items]="tabs"
            [selectedItemKeys]="[selectedTab]"
            [iconPosition]="'start'"
            (onItemClick)="selectedTab = $event.itemData.key"
            [scrollByContent]="true"
            [scrollingEnabled]="true"
            [showNavButtons]="false"></dx-tabs>
    }
</div>

@if (selectedTab === 'glCodes' && showGlCodes) {
    <app-gl-codes [offset]="gridOffset"/>
} @else if (selectedTab === 'glClients' && showGlCodesClients) {
    <app-gl-code-clients [offset]="gridOffset"/>
}